'use strict';

exports.__esModule = true;
exports['default'] = {
  background: {
    image: '/background-blurred.jpg',
    size: 'cover'
  },
  props: {
    'tournamentId': ':tournamentId'
  },
  title: function title(getState, props) {
    var club = getState().tournaments.clubsById[props.tournamentId];

    return 'Final ' + club.name;
  },
  type: 'Final'
};
module.exports = exports['default'];